import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import "../index.css"

// Inputs
import { RadioButton } from 'primereact/radiobutton'
import { TextAreaField, Button, CheckboxField, DropDownField } from '../../../helpers'

//utils
import { round } from '../../../utils';

// common
import Loading from "../../../common/Loading"

// components
import CNSellerPOItemsList from './CNSellerPOItemsList';
import CNBuyerInvoiceItems from './CNBuyerInvoiceItems';

// Apis
import { insertBuyerCreditNote } from '../../../services/api/adjustmentNotes';

// redux
import { raiseToast } from '../../../services/redux/reducers/toast/toast';

const CreateCreditNote = (props) => {

    const dispatch = useDispatch()

    const { buyerInvoice, buyerCreditNotes, userId, adjustmentReasons, companyWarehouses } = props

    const [selectedBuyerInvoiceItemIds, setSelectedBuyerInvoiceItemIds] = useState([])
    const [buyerInvoiceItemsPIPunch, setBuyerInvoiceItemsPIPunch] = useState(props.buyerInvoiceItemsPIPunch)
    const [rejectedReason, setRejectedReason] = useState(null)
    const [isRefillOpenPOProductsQty, setIsRefillOpenPOProductsQty] = useState(false)
    const [isReturnToSeller, setIsReturnToSeller] = useState(false)
    const [isLogisticsCharge, setIsLogisticsCharge] = useState(false)
    const [isLoaderVisible, setIsLoaderVisible] = useState(false)
    const [remarksObj, setRemarksObj] = useState({})
    const [pmWarehouseId, setpmWarehouseId] = useState(null)
    const [isNextButtonClicked, setIsNextButtonClicked] = useState(false)
    const [selectedBuyerInvoiceItemsPIPunch, setSelectedBuyerInvoiceItemsPIPunch] = useState([])
    const [selectedItemsReplacementLog, setSelectedItemsReplacementLog] = useState([])

    const [visibleClientHoldDialog, setVisibleClientHoldDialog] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        setBuyerInvoiceItemsPIPunch(props.buyerInvoiceItemsPIPunch);
    }, [props.buyerInvoiceItemsPIPunch])

    const handleSubmitCreditNote = async () => {

        if (selectedBuyerInvoiceItemIds.length == 0 && !isLogisticsCharge) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select products", life: 3000 }))
        }

        if (!rejectedReason) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select reason for rejection", life: 3000 }))
        }

        if (!pmWarehouseId) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select warehouse", life: 3000 }))
        }

        if (!remarksObj.rejectionRemarks || remarksObj.rejectionRemarks.trim() === "") {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter rejection remarks", life: 3000 }))

        }

        if (!remarksObj.correctiveActionRemarks || remarksObj.correctiveActionRemarks.trim() === "") {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter corrective action remarks", life: 3000 }))
        }

        if (!remarksObj.preventiveActionRemarks || remarksObj.preventiveActionRemarks.trim() === "") {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter preventive action remarks", life: 3000 }))
        }

        let remarks = ""
        if (remarksObj.rejectionRemarks) {
            remarks = "Reason for Rejection: " + remarksObj.rejectionRemarks.trim()
        }

        if (remarksObj.correctiveActionRemarks) {
            remarks = remarks + ",\n Corrective Action: " + remarksObj.correctiveActionRemarks.trim()
        }

        if (remarksObj.preventiveActionRemarks) {
            remarks = remarks + ",\n Preventive Action: " + remarksObj.preventiveActionRemarks.trim()
        }

        let qtyErrorBuyerInvoiceItems = []
        selectedBuyerInvoiceItemsPIPunch.map(eachBuyerInvoiceItem => {
            if (!eachBuyerInvoiceItem.creditNoteProductQuantity) {
                qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter quantity for " + eachBuyerInvoiceItem.productName + " | " + eachBuyerInvoiceItem.productSpecification, life: 3000 }))
            }

            let totalSpoCreditNoteQty = 0
            eachBuyerInvoiceItem.sellerPOItems.map(eachSellerPOItem => {
                eachSellerPOItem.piPunchItems.map(eachPIPunchItem => totalSpoCreditNoteQty += parseFloat(eachPIPunchItem.spoProductPiPunchCreditNoteQty))
            })

            if (totalSpoCreditNoteQty === 0) {
                qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter seller po product quantity for  " + eachBuyerInvoiceItem.productName + " | " + eachBuyerInvoiceItem.productSpecification, life: 3000 }))
            } else {
                if (totalSpoCreditNoteQty > eachBuyerInvoiceItem.creditNoteProductQuantity || totalSpoCreditNoteQty < eachBuyerInvoiceItem.creditNoteProductQuantity) {
                    qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                    return dispatch(raiseToast({ severity: 'warn', detail: "Total of entered seller po product qty " + totalSpoCreditNoteQty + " should be equal to entered creditnote product qty " + eachBuyerInvoiceItem.creditNoteProductQuantity + " for " + eachBuyerInvoiceItem.productName + " | " + eachBuyerInvoiceItem.productSpecification, life: 3000 }))
                }
            }

            if (rejectedReason === 8 && eachBuyerInvoiceItem.creditNoteUnitPrice >= eachBuyerInvoiceItem.unitPrice) {
                qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                return dispatch(raiseToast({ severity: 'warn', detail: `Credit Note price should not be more than or equal to invoice price ${eachBuyerInvoiceItem.unitPrice} for ${eachBuyerInvoiceItem.productName} | ${eachBuyerInvoiceItem.productSpecification}`, life: 3000 }))
            }
        })

        if (qtyErrorBuyerInvoiceItems != 0) {
            return false
        }

        if(isRefillOpenPOProductsQty && !isReturnToSeller){
            setVisibleClientHoldDialog(true)
        }
        else{
            insertAdjustmentNote(false)
        }
    }

    const insertAdjustmentNote = async (clientHold) => {

        let remarks = ""
        if (remarksObj.rejectionRemarks) {
            remarks = "Reason for Rejection: " + remarksObj.rejectionRemarks.trim()
        }

        if (remarksObj.correctiveActionRemarks) {
            remarks = remarks + ",\n Corrective Action: " + remarksObj.correctiveActionRemarks.trim()
        }

        if (remarksObj.preventiveActionRemarks) {
            remarks = remarks + ",\n Preventive Action: " + remarksObj.preventiveActionRemarks.trim()
        }

        let newCreditNoteObj = {
            adjustmentTypeId: 1,
            remarks: remarks,
            adjustmentReasonId: rejectedReason,
            toBeRefilled: isRefillOpenPOProductsQty,
            returnToSeller: isReturnToSeller,
            createdBy: userId,
            companyId: buyerInvoice.companyId,
            branchId: buyerInvoice.branchId,
            buyerInvoiceId: buyerInvoice?.buyerInvoiceId,
            linkedAdjustmentNoteId: 1, //linked BCN Id for SDN,
            sellerPIPunchItems: [],
            updatedAt: new Date(),
            statusId: 7,
            supplyTypeId: buyerInvoice?.supplyTypeId,
            pmWarehouseId: pmWarehouseId,
            clientHold: clientHold
        }

        if (isLogisticsCharge) {
            newCreditNoteObj.adjustedLogisticsbeforeTax = buyerInvoice.logisticsBeforeTax
            newCreditNoteObj.adjustedLogisticsGSTRate = buyerInvoice.logisticsGSTRate
            newCreditNoteObj.adjustedLogisticsWithTax = buyerInvoice.logisticsWithTax
        }

        let sellerDebitNoteItems = []
        selectedBuyerInvoiceItemsPIPunch.map((eachBuyerInvoiceItem) => {
            eachBuyerInvoiceItem.sellerPOItems?.forEach((sellerPOItem) => {
                sellerPOItem.piPunchItems.forEach((piPunchItem) => {
                    if (piPunchItem.spoProductPiPunchCreditNoteQty > 0) {
                        newCreditNoteObj.sellerPIPunchItems.push({
                            buyerInvoiceItemId: eachBuyerInvoiceItem.buyerInvoiceItemId,
                            sellerPIPunchItemId: piPunchItem.sellerPIPunchItemId,
                            adjustedQty: piPunchItem.spoProductPiPunchCreditNoteQty,
                            adjustedPricePerUnit: eachBuyerInvoiceItem.companyQtyMultiplier ? round(eachBuyerInvoiceItem.creditNoteUnitPrice * eachBuyerInvoiceItem.companyQtyMultiplier) : eachBuyerInvoiceItem.creditNoteUnitPrice,
                            createdBy: userId,
                        })

                        if (isReturnToSeller) {
                            const data = {
                                sellerPIPunchId: piPunchItem.sellerPIPunchId,
                                adjustmentTypeId: 3,
                                docNo: piPunchItem.sellerPIPunchDocNo,
                                fileNo: piPunchItem.sellerPIPunchfileNo,
                                companyId: piPunchItem.sellerCompanyId,
                                branchId: piPunchItem.sellerBranchId,
                                adjustedLogisticsbeforeTax: 0,
                                adjustedLogisticsGSTRate: 0,
                                adjustedLogisticsWithTax: 0,
                                adjustedOthersWithTax: 0,
                                sellerPIPunchItemId: piPunchItem.sellerPIPunchItemId,
                                adjustedQty: piPunchItem.spoProductPiPunchCreditNoteQty,
                                adjustedPricePerUnit: piPunchItem.unitPrice,
                                createdBy: userId,
                                statusId: 7
                            }
                            sellerDebitNoteItems.push(data)
                        }
                    }
                })
            })
        })

        let sellerDebitNotes = []
        if(sellerDebitNoteItems.length > 0){
            const sellerPIPunchIds = _.uniqBy(sellerDebitNoteItems, 'sellerPIPunchId').map(obj => obj.sellerPIPunchId)

            sellerPIPunchIds.map(eachPIPunchId => {
                const relatedDebitNoteItems = sellerDebitNoteItems.filter(eachDebitNoteItem => eachDebitNoteItem.sellerPIPunchId === eachPIPunchId)
                const newDebitNote = {
                    sellerPIPunchId: relatedDebitNoteItems[0].sellerPIPunchId,
                    adjustmentTypeId: 3,
                    docNo: relatedDebitNoteItems[0].docNo,
                    fileNo: relatedDebitNoteItems[0].fileNo,
                    companyId: relatedDebitNoteItems[0].companyId,
                    branchId: relatedDebitNoteItems[0].branchId,
                    adjustedLogisticsbeforeTax: 0,
                    adjustedLogisticsGSTRate: 0,
                    adjustedLogisticsWithTax: 0,
                    adjustedOthersWithTax: 0,
                    createdBy: userId,
                    statusId: 7
                }

                const newDebitNoteItems = []
                relatedDebitNoteItems.map(eachDebitNoteItem => {
                    newDebitNoteItems.push({
                        sellerPIPunchItemId: eachDebitNoteItem.sellerPIPunchItemId,
                        adjustedQty: eachDebitNoteItem.adjustedQty,
                        adjustedPricePerUnit: eachDebitNoteItem.adjustedPricePerUnit,
                        createdBy: userId
                    })
                })

                sellerDebitNotes.push({
                    adjustmentNote: newDebitNote,
                    adjustmentNoteItems: newDebitNoteItems
                })
            })
        }

        if (window.confirm("Are you sure you want to continue?")) {
            setIsLoaderVisible(true)
            const addAdjustmentNoteResponse = await insertBuyerCreditNote({ adjustmentNoteObj: newCreditNoteObj, buyerInvoice, documentName: "Buyer Credit Note", doGeneratePDF: false, sellerDebitNotes, docItemReplacementLogsData: selectedItemsReplacementLog })
            console.log("addAdjustmentNote-Response", addAdjustmentNoteResponse)

            if (addAdjustmentNoteResponse.failure) {
                setIsLoaderVisible(false)
                return dispatch(raiseToast({ severity: 'error', detail: addAdjustmentNoteResponse.data.error, life: 3000 }))
            }
            else {
                setIsLoaderVisible(false)
                dispatch(raiseToast({ severity: 'success', detail: "Credit Note added successfully", life: 3000 }))
                navigate(`/credit_note/${addAdjustmentNoteResponse?.data?.adjustmentNoteId}`)
            }
            setIsLoaderVisible(false)
        }
    }

    const handleReasonForRejectionChange = (event) => {
        event.stopPropagation()
        setRejectedReason(event.target.value)

        let relatedAdjustmentReason = adjustmentReasons.find(eachReason => eachReason.adjustmentReasonId === event.target.value)
        if ([7, 8].includes(relatedAdjustmentReason?.adjustmentReasonId)) {
            if (buyerInvoiceItemsPIPunch?.length > 0) {
                let relatedBuyerInvoiceItemIds = []
                let updatedBuyerInvoiceItemsPIPunch = buyerInvoiceItemsPIPunch?.map(eachInvoiceItem => {
                    if (eachInvoiceItem.availableCreditNoteQty > 0) {
                        eachInvoiceItem["creditNoteProductQuantity"] = eachInvoiceItem.availableCreditNoteQty
                        if (eachInvoiceItem.isReplaced) {
                            relatedBuyerInvoiceItemIds.push(eachInvoiceItem.replacedBuyerInvoiceItemId)
                            if (eachInvoiceItem.replacedBuyerInvoiceItems?.length > 0) {
                                eachInvoiceItem.replacedBuyerInvoiceItems.map(eachReplacedItem => {
                                    eachReplacedItem["creditNoteProductQuantity"] = eachReplacedItem.availableCreditNoteQty
                                })
                            }
                        }
                        else {
                            relatedBuyerInvoiceItemIds.push(eachInvoiceItem.buyerInvoiceItemId)
                        }
                    }

                    return eachInvoiceItem
                })

                setBuyerInvoiceItemsPIPunch([...updatedBuyerInvoiceItemsPIPunch])

                if (relatedAdjustmentReason?.adjustmentReasonId === 8) {
                    setSelectedBuyerInvoiceItemIds([])
                } else {
                    setSelectedBuyerInvoiceItemIds(relatedBuyerInvoiceItemIds)
                }
            }
        }
        else {
            setSelectedBuyerInvoiceItemIds([])
        }

        if ([7, 8].includes(parseInt(event.target.value))) {
            setIsRefillOpenPOProductsQty(false)
        }

        let updatedBuyerInvoiceItemsPIPunch = buyerInvoiceItemsPIPunch.map(eachBuyerInvoiceItem => {
            eachBuyerInvoiceItem.creditNoteUnitPrice = eachBuyerInvoiceItem.unitPrice
            return eachBuyerInvoiceItem
        })

        setBuyerInvoiceItemsPIPunch([...updatedBuyerInvoiceItemsPIPunch])
    }

    const handleRefillOpenpoProductsChange = (event) => {
        event.stopPropagation()

        let isRefillOpenPOProductsQty = false

        if (event.target.checked) {
            isRefillOpenPOProductsQty = true
        }

        setIsRefillOpenPOProductsQty(isRefillOpenPOProductsQty)
    }

    const handleReturnToSellerChange = (event) => {
        event.stopPropagation()

        let isReturnToSeller = false
        let rejectReason = ''

        if (event.target.checked) {
            isReturnToSeller = true

            let relatedAdjustmentReason = adjustmentReasons.find(eachReason => eachReason.adjustmentReasonName === "Rejected")
            if (!relatedAdjustmentReason) {
                return dispatch(raiseToast({ severity: 'warn', detail: "No rejected option found in reasons", life: 3000 }))
            }
            rejectReason = relatedAdjustmentReason?.adjustmentReasonId
        }

        if (selectedBuyerInvoiceItemIds.length > 0) {
            setSelectedBuyerInvoiceItemIds([])
        }

        setIsReturnToSeller(isReturnToSeller)
        setRejectedReason(rejectReason)

        let updatedBuyerInvoiceItemsPIPunch = buyerInvoiceItemsPIPunch.map(eachBuyerInvoiceItem => {
            eachBuyerInvoiceItem.creditNoteUnitPrice = eachBuyerInvoiceItem.unitPrice
            return eachBuyerInvoiceItem
        })

        setBuyerInvoiceItemsPIPunch([...updatedBuyerInvoiceItemsPIPunch])
    }

    const handleSelectAllBuyerInvoiceItems = (event) => {
        let buyerInvoiceItemIds = []
        if (event.target.checked) {
            buyerInvoiceItemIds = buyerInvoiceItemsPIPunch.map(eachBuyerInvoiceItem => {
                if (eachBuyerInvoiceItem.isReplaced) {
                    return eachBuyerInvoiceItem.replacedBuyerInvoiceItemId
                }
                return eachBuyerInvoiceItem.buyerInvoiceItemId
            })
        }

        setSelectedBuyerInvoiceItemIds(buyerInvoiceItemIds)
    }

    const handleSelectBuyerInvoiceItem = (event, selectedBuyerInvoiceItemId) => {
        if (event.target.checked) {
            selectedBuyerInvoiceItemIds.push(selectedBuyerInvoiceItemId)
            setSelectedBuyerInvoiceItemIds([...selectedBuyerInvoiceItemIds])
        } else {
            let relatedSelectedBuyerInvoiceItemIds = selectedBuyerInvoiceItemIds.filter(eachBuyerInvoiceItemId => eachBuyerInvoiceItemId !== selectedBuyerInvoiceItemId)
            setSelectedBuyerInvoiceItemIds([...relatedSelectedBuyerInvoiceItemIds])
        }
    }

    const handleCompanyWarehouseChange = (event) => {
        setpmWarehouseId(event.target.value)
    }

    const handleOnClickNextButton = (event) => {
        if (selectedBuyerInvoiceItemIds.length == 0 && !isLogisticsCharge) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select products", life: 3000 }))
        }

        if (!rejectedReason) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select reason for rejection", life: 3000 }))
        }

        if (!pmWarehouseId) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select warehouse", life: 3000 }))
        }

        if (!remarksObj.rejectionRemarks || remarksObj.rejectionRemarks.trim() === "") {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter rejection remarks", life: 3000 }))

        }

        if (!remarksObj.correctiveActionRemarks || remarksObj.correctiveActionRemarks.trim() === "") {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter corrective action remarks", life: 3000 }))
        }

        if (!remarksObj.preventiveActionRemarks || remarksObj.preventiveActionRemarks.trim() === "") {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter preventive action remarks", life: 3000 }))
        }

        let relatedSelectedBuyerInvoiceItems = buyerInvoiceItemsPIPunch.filter(eachBuyerInvoiceItem => selectedBuyerInvoiceItemIds?.includes(eachBuyerInvoiceItem.isReplaced ? eachBuyerInvoiceItem.replacedBuyerInvoiceItemId : eachBuyerInvoiceItem.buyerInvoiceItemId))

        console.log("relatedSelectedBuyerInvoiceItems", relatedSelectedBuyerInvoiceItems)

        // let isOriginalSellerPODocNoUnavailable = false 
        let originalSellerPOUnavailableProductName = ''
        let qtyErrorBuyerInvoiceItems = []
        relatedSelectedBuyerInvoiceItems.map(eachBuyerInvoiceItem => {
            if (!eachBuyerInvoiceItem.creditNoteProductQuantity) {
                qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter quantity for " + eachBuyerInvoiceItem.productName + " | " + eachBuyerInvoiceItem.productSpecification, life: 3000 }))
            }

            if (rejectedReason === 8 && eachBuyerInvoiceItem.creditNoteUnitPrice >= eachBuyerInvoiceItem.unitPrice) {
                qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                return dispatch(raiseToast({ severity: 'warn', detail: `Credit Note price should not be more than or equal to invoice price ${eachBuyerInvoiceItem.unitPrice} for ${eachBuyerInvoiceItem.productName} | ${eachBuyerInvoiceItem.productSpecification}`, life: 3000 }))
            }          
        })

        // if(isOriginalSellerPODocNoUnavailable){
        //     return dispatch(raiseToast({ severity: 'warn', detail: `Original seller PO is not found for product - ${originalSellerPOUnavailableProductName}`, life: 3000 }))
        // }

        if (qtyErrorBuyerInvoiceItems.length != 0) {
            return false
        }

        setIsLoaderVisible(true)

        let selectedBuyerInvoiceItemsReplacementLog = []

        let relatedBuyerInvoiceItemsPIPunch = buyerInvoiceItemsPIPunch?.filter(eachBuyerInvoiceItem => selectedBuyerInvoiceItemIds.includes(eachBuyerInvoiceItem.buyerInvoiceItemId))

        relatedBuyerInvoiceItemsPIPunch = JSON.parse(JSON.stringify(relatedBuyerInvoiceItemsPIPunch))

        relatedBuyerInvoiceItemsPIPunch?.map(eachBuyerInvoiceItem => {
            if (eachBuyerInvoiceItem.companyQtyMultiplier) {
                eachBuyerInvoiceItem.qty = round(parseFloat(eachBuyerInvoiceItem.qty) / eachBuyerInvoiceItem.companyQtyMultiplier)
                eachBuyerInvoiceItem.availableCreditNoteQty = round(parseFloat(eachBuyerInvoiceItem.availableCreditNoteQty) / eachBuyerInvoiceItem.companyQtyMultiplier)
                eachBuyerInvoiceItem.creditNoteProductQuantity = round(parseFloat(eachBuyerInvoiceItem.creditNoteProductQuantity) / eachBuyerInvoiceItem.companyQtyMultiplier)
            }
            return eachBuyerInvoiceItem
        })

        buyerInvoiceItemsPIPunch.forEach(eachBuyerInvoiceItem => {
            if (eachBuyerInvoiceItem.isReplaced && selectedBuyerInvoiceItemIds.includes(eachBuyerInvoiceItem?.replacedBuyerInvoiceItemId)) {
                if (eachBuyerInvoiceItem?.relatedDocItemReplacementLog) {
                    let docItemReplacementLog = {
                        docItemReplacementMapId: eachBuyerInvoiceItem.docItemReplacementMapId,
                        docNo: eachBuyerInvoiceItem.docNo,
                        unitPrice: eachBuyerInvoiceItem.creditNoteUnitPrice,
                        qtyReplaced: eachBuyerInvoiceItem.creditNoteProductQuantity,
                        GSTRate: eachBuyerInvoiceItem.GSTRate,
                    }

                    selectedBuyerInvoiceItemsReplacementLog.push(docItemReplacementLog)
                }

                eachBuyerInvoiceItem.replacedBuyerInvoiceItems.forEach(relatedReplacedBuyerInvoiceItem => {
                    let eachUnreplaceBuyerInvoiceItem = relatedBuyerInvoiceItemsPIPunch.find(item => item.buyerInvoiceItemId === relatedReplacedBuyerInvoiceItem.buyerInvoiceItemId);

                    if (eachUnreplaceBuyerInvoiceItem) {
                        eachUnreplaceBuyerInvoiceItem.qty = round(parseFloat(eachUnreplaceBuyerInvoiceItem.qty) + parseFloat(relatedReplacedBuyerInvoiceItem.qty));
                        eachUnreplaceBuyerInvoiceItem.availableCreditNoteQty = round(parseFloat(eachUnreplaceBuyerInvoiceItem.availableCreditNoteQty) + parseFloat(relatedReplacedBuyerInvoiceItem.availableCreditNoteQty));
                        eachUnreplaceBuyerInvoiceItem.creditNoteProductQuantity = round(parseFloat(eachUnreplaceBuyerInvoiceItem.creditNoteProductQuantity) + parseFloat(relatedReplacedBuyerInvoiceItem.creditNoteProductQuantity));
                    } else {
                        relatedBuyerInvoiceItemsPIPunch.push(relatedReplacedBuyerInvoiceItem)
                    }
                })
            }
        })

        let isOriginalSellerPODocNoUnavailable = false
        if (isReturnToSeller) {
            relatedBuyerInvoiceItemsPIPunch.map(eachBuyerInvoiceItem => {
                eachBuyerInvoiceItem.sellerPOItems?.forEach(eachSellerPOItem => {
                    if (eachSellerPOItem?.sellerCompanyId === buyerInvoice.pmCompanyId) {
                        const relatedSmartStockMoves = eachSellerPOItem.smartStockMoves.some(eachSmartStockMoves => {
                            if (!eachSmartStockMoves.sellerPODocNo) {
                                originalSellerPOUnavailableProductName = eachBuyerInvoiceItem.productName
                                return true
                            }
                            return false
                        })

                        if (relatedSmartStockMoves) {
                            isOriginalSellerPODocNoUnavailable = true
                        }
                    }
                })
            })
        }

        if(isOriginalSellerPODocNoUnavailable){
            return dispatch(raiseToast({ severity: 'warn', detail: `Original seller PO is not found for product - ${originalSellerPOUnavailableProductName}`, life: 3000 }))
        }

        setSelectedBuyerInvoiceItemsPIPunch([...relatedBuyerInvoiceItemsPIPunch])
        setSelectedItemsReplacementLog(selectedBuyerInvoiceItemsReplacementLog)
        setIsLoaderVisible(false)
        setIsNextButtonClicked(true)
    }

    const handleOnClickBackButton = (event) => {
        setIsLoaderVisible(true)
        setIsNextButtonClicked(false)
        setIsLoaderVisible(false)
    }

    const handleChangeRemarks = (event) => {

        if (event.target.name === "rejectionReasonRemarks") {
            remarksObj.rejectionRemarks = event.target.value
        }
        else if (event.target.name === "correctiveActionRemarks") {
            remarksObj.correctiveActionRemarks = event.target.value
        }
        else {
            remarksObj.preventiveActionRemarks = event.target.value
        }

        setRemarksObj({ ...remarksObj })
    }

    const handleClientHoldAccept = () => {
        setVisibleClientHoldDialog(false)
        insertAdjustmentNote(true)
    }

    const handleClientHoldReject = () => {
        setVisibleClientHoldDialog(false)
        insertAdjustmentNote(false)
    }

    let isLogisticsInCreditNote = false
    if (buyerInvoice.logisticsBeforeTax) {
        buyerCreditNotes.map(eachCreditNote => {
            console.log("buyerCreditNotes", buyerCreditNotes)
            if (eachCreditNote.adjustedLogisticsWithTax && eachCreditNote.statusId !== 6) {
                isLogisticsInCreditNote = true
            }
        })
    }

    let relatedRejectedReason = adjustmentReasons.find(eachReason => eachReason.adjustmentReasonId === rejectedReason)

    return (
        <div className='credit-note-dialog'>
            <ConfirmDialog 
                group="declarative"  
                visible={visibleClientHoldDialog} 
                onHide={() => setVisibleClientHoldDialog(false)} 
                message="Are materials held by client?" 
                header="" 
                icon="pi pi-exclamation-triangle" 
                accept={handleClientHoldAccept} 
                reject={handleClientHoldReject} 
            />
            {
                !isNextButtonClicked ?
                    <>
                        <div className='p-2 mb-2'>
                            <CheckboxField
                                name={'returnToSeller'}
                                inputId={'returnToSeller'}
                                label={"Return To Seller"}
                                value={isReturnToSeller}
                                checked={isReturnToSeller === true}
                                onChange={handleReturnToSellerChange}
                                labelStyle={{ fontWeight: 'bold' }}
                            />
                        </div>
                        <label style={{ color: "#343840", fontWeight: "bold", fontSize: "13px" }} className='ml-2 mt-2'>
                            Reason For Rejection:
                        </label>
                        <div className="flex p-2">
                            {adjustmentReasons.map(eachReason => {
                                let adjustmentReasonDisableCond = false
                                let adjustmentReasonToolTipText = ''
                                if(isReturnToSeller){
                                    adjustmentReasonDisableCond = true
                                }
                                else{
                                    const activeBuyerCreditNotes = buyerCreditNotes.filter(eachCreditNote => eachCreditNote.statusId !== 6)
                                    if(activeBuyerCreditNotes.length && eachReason.adjustmentReasonId === 7){
                                        adjustmentReasonDisableCond = true
                                        adjustmentReasonToolTipText = 'Reinvoicing reason can only be selected for first credit note!'
                                    }
                                }

                                return (
                                    <div className="flex flex-row mt-1 ml-3">
                                        <RadioButton 
                                            inputId={eachReason.adjustmentReasonId} 
                                            value={eachReason.adjustmentReasonId} 
                                            checked={rejectedReason === eachReason.adjustmentReasonId} 
                                            onChange={(event) => handleReasonForRejectionChange(event)} 
                                            disabled={adjustmentReasonDisableCond} 
                                            tooltip={adjustmentReasonToolTipText}
                                            tooltipOptions={{ position: 'top', showOnDisabled: true }}
                                        />
                                        <label htmlFor={eachReason.adjustmentReasonId} className="" style={{ fontSize: "13px" }}>{eachReason.adjustmentReasonName}</label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="flex p-2">
                            <div className="flex flex-column col-12 mb-2 md:col-4 lg:col-3 lg:mb-0">
                                <DropDownField name="pmWarehouseId" labelText="Warehouse" placeholder={"Please Select"} options={companyWarehouses} optionLabel="warehouseName" optionValue="warehouseId" value={pmWarehouseId} showClear onChange={(e) => handleCompanyWarehouseChange(e)} required />
                            </div>
                            <div className='p-2 pt-0 mt-5'>
                                <CheckboxField
                                    name={'toBeRefilled'}
                                    inputId={'toBeRefilled'}
                                    label={"Re-procurement required"}
                                    value={isRefillOpenPOProductsQty}
                                    checked={isRefillOpenPOProductsQty === true}
                                    disabled={[7, 8].includes(rejectedReason)}
                                    onChange={(event) => handleRefillOpenpoProductsChange(event)}
                                />
                            </div>
                        </div>
                        <label style={{ color: "#343840", fontWeight: "bold", fontSize: "13px" }}>
                            Select Products:
                        </label>
                        {
                            buyerInvoiceItemsPIPunch.length > 0 ?
                                <div className="p-card py-2">
                                    <label>
                                        <CheckboxField
                                            name={'selectAll'}
                                            label={"Select All"}
                                            checked={selectedBuyerInvoiceItemIds.length === buyerInvoiceItemsPIPunch?.length}
                                            onChange={handleSelectAllBuyerInvoiceItems}
                                            disabled={relatedRejectedReason?.adjustmentReasonName === "ReInvoicing"}
                                        />
                                    </label>
                                    {
                                        buyerInvoiceItemsPIPunch.map((eachBuyerInvoiceItem, index) => {
                                            return (
                                                <CNBuyerInvoiceItems
                                                    buyerInvoiceItem={eachBuyerInvoiceItem}
                                                    rejectedReasonName={relatedRejectedReason?.adjustmentReasonName}
                                                    selectedBuyerInvoiceItemIds={selectedBuyerInvoiceItemIds}
                                                    handleSelectBuyerInvoiceItem={handleSelectBuyerInvoiceItem}
                                                    buyerInvoiceItemsPIPunch={buyerInvoiceItemsPIPunch}
                                                    setBuyerInvoiceItemsPIPunch={setBuyerInvoiceItemsPIPunch}
                                                />
                                            )
                                        })
                                    }
                                    {
                                        !isLogisticsInCreditNote && buyerInvoice.logisticsWithTax ?
                                            <div>
                                                <br />
                                                <label>
                                                    <CheckboxField
                                                        name={'logisticCharge'}
                                                        label={"Logistics Charge"}
                                                        checked={isLogisticsCharge}
                                                        onChange={(event) => setIsLogisticsCharge(event.target.checked)}
                                                    />
                                                </label>
                                                <br />
                                            </div>
                                            : null
                                    }
                                </div>
                                : ""
                        }
                        <div style={{ marginTop: "10px", marginBottom: "20px" }}>
                            <label style={{ color: "#343840", fontWeight: "bold", fontSize: "13px", marginBottom: "15px" }}>
                                Remarks
                            </label>
                            <div className='grid'>
                                <div className="flex flex-column col-6 text-area">
                                    <TextAreaField name="rejectionReasonRemarks" labelText="Reason for rejection" rows={2} onChange={(e) => handleChangeRemarks(e)} value={remarksObj.rejectionRemarks} />
                                </div>
                                <div className="flex flex-column col-6 text-area">
                                    <TextAreaField name="correctiveActionRemarks" labelText="Corrective action" rows={2} onChange={(e) => handleChangeRemarks(e)} value={remarksObj.correctiveActionRemarks} />
                                </div>
                                <div className="flex flex-column col-6 text-area">
                                    <TextAreaField name="preventiveActionRemarks" labelText="Preventive action" rows={2} onChange={(e) => handleChangeRemarks(e)} value={remarksObj.preventiveActionRemarks} />
                                </div>
                            </div>
                        </div>
                        {/* <div className='mt-3 flex justify-content-end'>
                                <Button className="small-btn" label="Create" onClick={handleSubmitCreditNote} />
                        </div> */}
                        <div className='mt-3 flex justify-content-end'>
                            <Button label={"NEXT"} onClick={(event) => handleOnClickNextButton(event)} />
                        </div>
                    </>
                    :
                    <>
                        <label style={{ color: "#343840", fontWeight: "bold", fontSize: "13px" }}>
                            PI Punch for selected Products:
                        </label>
                        {
                            selectedBuyerInvoiceItemsPIPunch.length > 0 ?
                                <div className="p-card py-2">
                                    {
                                        selectedBuyerInvoiceItemsPIPunch.map((eachCreditNoteItem, index) => {
                                            return (
                                                <CNSellerPOItemsList
                                                    buyerInvoiceItemsPIPunch={buyerInvoiceItemsPIPunch}
                                                    rejectedReasonName={relatedRejectedReason?.adjustmentReasonName}
                                                    buyerInvoiceItem={eachCreditNoteItem}
                                                    selectedBuyerInvoiceItemIds={selectedBuyerInvoiceItemIds}
                                                    handleSelectBuyerInvoiceItem={handleSelectBuyerInvoiceItem}
                                                    setBuyerInvoiceItemsPIPunch={setBuyerInvoiceItemsPIPunch}
                                                    selectedBuyerInvoiceItemsPIPunch={selectedBuyerInvoiceItemsPIPunch}
                                                    setSelectedBuyerInvoiceItemsPIPunch={setSelectedBuyerInvoiceItemsPIPunch}
                                                />
                                            )
                                        })
                                    }
                                </div>
                                : ""
                        }
                        <div className='mt-3 flex justify-content-end'>
                            <Button className="mr-3" label={"Back"} onClick={(event) => handleOnClickBackButton(event)} />
                            <Button className="small-btn" label="Create" onClick={handleSubmitCreditNote} />
                        </div>
                    </>

            }
            <Loading visible={isLoaderVisible} />
        </div>
    )
}

export default CreateCreditNote